import React from "react";
import { Container, Typography, Grid, Card, CardContent, CardMedia, Link, IconButton } from "@mui/material";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import RoomIcon from "@mui/icons-material/Room";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import GoogleMapReact from "google-map-react";

const AnyReactComponent = ({ text }) => (
  <div style={{ color: "red", fontSize: "24px" }}>
    <RoomIcon />
  </div>
);

function ContactUsPage() {
  return (
    <Container maxWidth="md" sx={{ textAlign: "center", paddingTop: "50px" }}>
      <Typography variant="h4" gutterBottom>
        Contact Us
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Card sx={{ maxWidth: 400, margin: "auto" }}>
            <CardMedia component="img" height="auto" src="/static/logo.png" alt="Logo" />
            <CardContent sx={{ textAlign: "left" }}>
              <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                Hospital of the Holy Cross
              </Typography>
              <Typography variant="body2" gutterBottom sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <EmailIcon fontSize="small" />
                <Link href="mailto:hhc_calapan@yahoo.com.ph">hhc_calapan@yahoo.com.ph</Link>
              </Typography>
              <Typography
                variant="body2"
                sx={{ mt: 1, mb: 0.5, fontWeight: 600, display: "flex", alignItems: "center", gap: 0.5 }}
              >
                <PhoneIcon fontSize="small" /> Mobile
              </Typography>
              <Typography variant="body2" gutterBottom sx={{ pl: 0.5 }}>
                <Link href="tel:+639950193317">0995 019 3317</Link>
                {" · "}
                <Link href="tel:+639087443313">0908 744 3313</Link>
              </Typography>
              <Typography
                variant="body2"
                sx={{ mt: 1, mb: 0.5, fontWeight: 600, display: "flex", alignItems: "center", gap: 0.5 }}
              >
                <PhoneIcon fontSize="small" /> Landline
              </Typography>
              <Typography variant="body2" gutterBottom sx={{ pl: 0.5 }}>
                <Link href="tel:+63432885855">(043) 288-5855</Link>
                {" · "}
                <Link href="tel:+63432885854">288-5854</Link>
                {" · "}
                <Link href="tel:+63434416526">441-6526</Link>
              </Typography>
              <Typography variant="body2" sx={{ mt: 1, mb: 0.5, fontWeight: 600 }}>
                Doctors
              </Typography>
              <Typography variant="body2" gutterBottom sx={{ pl: 0.5 }}>
                Dra. Ingrid: <Link href="tel:+639166919153">0916 691 9153</Link>
              </Typography>
              <Typography variant="body2" gutterBottom sx={{ pl: 0.5 }}>
                Dr. Manny: <Link href="tel:+639179957782">0917 995 7782</Link>
              </Typography>
              <Typography variant="body1" gutterBottom sx={{ mt: 2, display: "flex", alignItems: "center", gap: 0.5 }}>
                <RoomIcon fontSize="small" /> Medrano, Calapan City, Philippines
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card sx={{ height: 400 }}>
            <GoogleMapReact
              bootstrapURLKeys={{ key: "AIzaSyA0l5mfMyUWnKDbnYAuTj-h5kBTjAhD99U" }}
              defaultCenter={{ lat: 13.411871, lng: 121.182171 }}
              defaultZoom={16}
            >
              <AnyReactComponent lat={13.411871} lng={121.182171} text="Marker" />
            </GoogleMapReact>
          </Card>
        </Grid>
      </Grid>
      <div style={{ marginTop: "20px" }}>
        <IconButton href="https://facebook.com">
          <FacebookIcon />
        </IconButton>
        <IconButton href="https://twitter.com">
          <TwitterIcon />
        </IconButton>
        <IconButton href="https://instagram.com">
          <InstagramIcon />
        </IconButton>
      </div>
    </Container>
  );
}

export default ContactUsPage;
